import classNames from 'classnames';
import { Button, FlexContainer, ToDoHeading, Txt, View } from 'components';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { useDataActions, useTenancy } from 'state';
import styles from './TenantsNotLinked.module.scss';

/**
 * TenantsNotLinked
 *
 * @return {JSX.Element}
 */
const TenantsNotLinked = ({ className, onSuccess }) => {
  const [isLoading, setIsLoading] = useState(false);
  const storageActions = useDataActions();
  const tenancyDoc = useTenancy();
  const { data: tenancyData } = tenancyDoc;

  const handleSendLinkToTenants = () => {
    setIsLoading(true);
    storageActions.tenancy
      .sendLinkToTenants(tenancyDoc)
      .then(() => {
        if (onSuccess) {
          onSuccess();
        } else {
          setIsLoading(false);
        }
      })
      .catch((e) => {
        console.warn('Failed to send link to tenants');
        console.error(e);
        setIsLoading(false);
      });
    console.log('Send link to tenants');
  };

  return (
    <FlexContainer
      className={classNames(
        styles.TenantsNotLinked,
        className,
        TenantsNotLinked.displayName
      )}
      column
      gap
    >
      <Txt bold>🔗 Tenants have not linked</Txt>
      <ToDoHeading
        description1="LINKING"
        description2="Tenants linked"
        completed={tenancyData.tenantUids.length}
        completedOf={tenancyData.tenantCount}
        noDivider
        black
        noLabel
        caption
      />
      <View>
        <View>
          <Txt regular>Tenants will have access to:</Txt>
        </View>
        <View>
          <Txt regular>- Basic property details. </Txt>
        </View>
        <View>
          <Txt regular>- Basic property details. </Txt>
        </View>
        <View>
          <Txt regular>- Property certificates (EPC, EICR, Gas Safety).</Txt>{' '}
        </View>
        <View>
          <Txt regular>- GOV.UK Right to rent checklist.</Txt>
        </View>
        <View>
          <Txt regular>- Tenancy agreement. </Txt>
        </View>
        <View>
          <Txt regular>- Where rent and deposit payments should be sent. </Txt>
        </View>
        <View>
          <Txt regular>- Deposit details and certificate. </Txt>
        </View>
        <View>
          <Txt regular>- Messaging channel for the tenancy.</Txt>
        </View>
      </View>
      <Txt regular>
        An email will be sent to the tenants with instructions on how to link.
        If you've already sent a link feel free to send a reminder using the
        button below.
      </Txt>
      <Txt bold>
        🔐 Propa uses end-to-end encryption to secure your information.
      </Txt>
      <Button
        flex
        success
        onClick={handleSendLinkToTenants}
        disabled={isLoading}
      >
        Send Tenants the Link Email
      </Button>
    </FlexContainer>
  );
};

TenantsNotLinked.displayName = 'TenantsNotLinked';

export default observer(TenantsNotLinked);
